<!-- 采购退货统计 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn search-picker">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">采购员</div>
                    <el-select
                        v-model="searchData.SIds"
                        multiple
                        collapse-tags
                        size="small"
                        class="search-item"
                        filterable
                        placeholder="请选择"
                        @visible-change="siVisibleChange($event)"
                    >
                        <el-option v-for="(item, index) in SIdList" :key="index" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">退货原因</div>
                    <el-select
                        v-model="searchData.SearchReason"
                        multiple
                        collapse-tags
                        size="small"
                        class="search-item"
                        filterable
                        placeholder="请选择"
                        style="width: 200px;"
                    >
                        <el-option v-for="(item, index) in reasonList" :key="index" :label="item.Text" :value="item.Id"></el-option>
                    </el-select>
                    <div class="search-name">提交时间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button size="small" class="search-btn btn-primary" v-if="permission.export" @click="exportData">
                            <i class="fa fa-file-excel-o"></i>
                            {{ permission.export }}
                        </el-button>    
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <ux-grid
                    ref="multipleTable"
                    :data="tableSaleData"
                    border
                    style="width: 100%"
                    show-summary
                    :summary-method="getSummaries"
                    :sort-config="{ defaultSort: { field: 'RTotalAmount', order: 'desc' } }"
                >
                    <ux-table-column resizable fixed width="50px" type="index" sortable title="排名"></ux-table-column>
                    <ux-table-column resizable fixed min-width="100px" field="SName" title="业务员"></ux-table-column>
                    <ux-table-column resizable min-width="100px" v-for="(item, index) in tableReason" :key="index+'i'" :title="item">
                        <template slot-scope="scope">
                            <span v-for="(item2, index2) in scope.row.ReasonsList" v-if="index == index2" :key="index2">
                                {{ index2 % 2 === 0 ? item2.Count:item2.Amount }}
                            </span>
                        </template>
                    </ux-table-column>
                    <ux-table-column resizable sortable width="110" fixed="right" field="ROrderCount" title="退货单数"></ux-table-column>
                    <ux-table-column resizable sortable width="130" fixed="right" field="RGoodsCount" title="退货商品总数"></ux-table-column>
                    <ux-table-column resizable sortable width="120" fixed="right" field="RTotalAmount" title="退货总额"></ux-table-column>
                </ux-grid>
            </div>
        </div>
        <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
            <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
            <span>您也可以打开新的窗口进行其他的操作</span>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            loading:false,
            showExportMsg:false,
            dateTimes: [],
            SIdList:[],
            dateFTimes: '',
            permission:{},
            searchData: {
                SearchReason: '',
                SIds: [],
                StartDate: '',
                EndDate: '',
            },
            tableSaleData: [],
            tableSaleDataLength: 0,
            tablePurchaseData: [],
            tablePurchaseDataLength: 0,
            tableReason:[],//退货原因
            reasonList:[],//退货原因主要用于查询
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created() {
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.dateTimes.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTimes.unshift(date2);

        this.searchData.StartDate = date2;
        this.searchData.EndDate = date1;
    },
    mounted() {
        this.permission = this.$util.getPermission('purchaseReturnStat');
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.getRemarkList();
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                } else if (index == 1) {
                    sums[index] = '';
                } else if (index < this.tableReason.length + 2) {
                    let s = 0;
                    data.forEach((e, i) => {
                        if (e.ReasonsList && e.ReasonsList.length > 0)
                            e.ReasonsList.forEach(ee => {
                                if (ee.Reason == column.title && ee.Reason.indexOf("(金额)") > -1) {
                                    s += ee.Amount;
                                }else if(ee.Reason == column.title && ee.Reason.indexOf("(数量)") > -1){
                                    s += ee.Count;
                                }
                            });
                    });
                    if(index % 2 === 0){
                        sums[index] = s;
                    }else{
                        if(s > 0){
                            sums[index] = s.toFixed(2)+"元";
                        }else{
                            sums[index] = s;
                        }
                    }
                } else {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        if(index === this.tableReason.length + 4)
                            sums[index] = sums[index].toFixed(2)+"元";
                    } else {
                        sums[index] = '';
                    }
                }
            });

            return [sums];
        },
        // 重置表单
        resetSearch() {
            let that = this;
            that.searchData.EntpId = this.searchData.EntpId;
            that.searchData.SIds = [];
            that.searchData.OrgIds = [];
            that.selectDate = '';
            that.dateTimes = [];

            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date1 = new Date(year1, month1, day1, 0);
            that.dateTimes.push(date1);

            //前一天设定的日期时间
            let year2, month2, day2;
            d.setTime(d.getTime());
            [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date2 = new Date(year2, month2, 1, 0);
            that.dateTimes.unshift(date2);

            that.searchData.StartDate = date2;
            that.searchData.EndDate = date1;
            that.searchData.SearchReason = [];
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/PurReturnPerfStat',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.tableSaleData = data.List;
                        this.tableReason = data.header;
                        this.tableSaleDataLength = res.count;
                    } else if (res.errcode != 201 && !data) {
                        this.tableSaleData = [];
                        this.tableSaleDataLength = 0;
                    }
                })
                .catch(() => {});
        },
        exportData() {
            let that = this;
            if (that.tableSaleData.length == 0) {
                that.$util.warningMsg('请筛选记录');
                return;
            }
            that.showExportMsg = true;
            that.$util
                .exportFile_post({
                    url: '/api/DataStatistics/PurReturnPerfStats_ToExport',
                    data: that.searchData
                })
                .then(res => {
                    that.showExportMsg = false;
                    that.$util.successMsg('导出成功');
                });
        },
        //获取备注下拉列表
        getRemarkList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetAttrs2?attrCode=pOrderReason',
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.reasonList = data;
                    }
                });
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length <= 1) {
                    that.$util.getPurchaserList().then(data => {
                        that.SIdList = data;
                    });
                }
            }
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            }
        },
        handleChangeFinishTime(val) {
            if (val) {
                this.searchData.PayStartDate = val[0];
                this.searchData.PayEndDate = val[1];
            }
        }
    }
};
</script>
<style lang="less">
.table-ctn {
    .elx-table--body-wrapper {
        .elx-body--row {
            td {
                height: 36px;
            }
        }
    }
}
</style>
<style lang="less" scoped>
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 65vh;
    left: 60vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
</style>